


































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import { pickObject } from "@root/utiles";
import TableHeaderSearch from "./children/TableHeaderSearch.vue";
import ImportTemplate from "./children/importTemplate/index.vue";
import CustomTableScrollWrap from "@/components/custom/CustomTableScrollWrap/index.vue";
import { moneyRegexp, zpNumRegexp } from "@root/lib/regexps.ts";

const wt = namespace("wt");
const product = namespace("product");
@Component({
  components: { TableHeaderSearch, ImportTemplate, CustomTableScrollWrap }
})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class ProductImportDialog extends Vue {
  @Prop({ default: false }) visible: Boolean;
  @Prop({ default: () => {} }) initData: Array<any>; // 回显已经添加的商品

  @wt.Action exportAllProductCode;
  @wt.Action downLoadProductTemplate;
  @product.Action queryPCRProductList;

  private dataList = [];
  private hasSelectDataList = [];
  private selectDataList = [];

  private searchStr = null;
  private selectSearchStr = null;
  private downloadLoading = false;
  private downloadTemplateErrorTxt = "";

  get dialogVisible() {
    return this.visible;
  }
  set dialogVisible(val) {
    this.$emit("update:visible");
  }
  get dataListComputed() {
    const { selectSearchStr: search, dataList } = this;
    return dataList.filter(
      data =>
        !search ||
        (data.productName + data.productCode)
          .toLowerCase()
          .includes(search.toLowerCase())
    );
  }
  get dataListLength() {
    return this.dataListComputed.length;
  }
  created() {
    this.dialogVisible = false;
  }
  onClose() {
    this.dialogVisible = false;
    this.$emit("close");
    this.resetDialog();
  }
  tableCellClassName({ row, column, rowIndex, columnIndex }) {
    row.index = rowIndex;
    column.index = columnIndex;
  }
  formatData(dataList) {
    const objectPicks = [
      "productCode",
      "productName",
      "salePrice",
      "productPrice",
      "skuInventory",
      "maxPerUser",
      "skus"
    ];
    return dataList.map(el => {
      const row = pickObject(el, objectPicks);
      if (!el.skus) {
        row["skus"] = [el];
        return row;
      }
      return row;
    });
  }
  handleSelectionChange(val) {
    this.selectDataList = val;
  }
  handleHasSelectChange(val) {
    this.hasSelectDataList = val;
  }
  handleConfirmSelect() {
    let { dataListComputed, formatData } = this;
    const newDataList = formatData(dataListComputed);
    this.$emit("confirm", newDataList);
  }
  onDeleteSelectedData(row, idx) {
    this.dataListComputed.splice(idx, 1);
    this.refreshWrapTableData();
  }

  onDeleteBatch() {
    try {
      if (!this.hasSelectDataList.length) {
        this.$message.warning("请选择商品后再点击批量删除！");
        return;
      }
      this.refClearSelection("selectedTableRef");
    } catch (error) {
      console.log(error);
    }
  }
  /**
   * refName: string | array
   */
  refClearSelection(refName) {
    this.$nextTick(() => {
      try {
        if (Array.isArray(refName)) {
          refName.forEach(ref => {
            (this.$refs[ref] as any).clearSelection();
          });
        } else {
          (this.$refs[refName] as any).clearSelection();
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  beforeDestroy() {
    // this.clearCacheDataList();
  }
  /**
   * 模板下载
   */
  async onFileDownload() {
    let timer = null;
    try {
      this.downloadLoading = true;
      this.downloadTemplateErrorTxt && (this.downloadTemplateErrorTxt = "");
      await this.exportAllProductCode();
      const res = await this.downLoadProductTemplate();
      const responseStr = (res && res.data && res.data.api) || "";
      if (responseStr.indexOf("http") > -1) {
        clearTimeout(timer);
        timer = setTimeout(async () => {
          this.downloadLoading = false;
          if (responseStr) {
            (this.$refs.importTemplateRef as any).createDownA(responseStr);
          }
        }, 4 * 1000);
      }
      // "notGenerated"
      if (responseStr.indexOf("not") > -1) {
        this.downloadTemplateErrorTxt = "生成模板失败，请点击重新下载";
        this.downloadLoading = false;
      }
    } catch (error) {
      this.downloadLoading = false;
      console.log(error);
    }
  }
  /**
   * 接收xlsx解析的json格式文件
   * 限制最大条数 1000
   * 活动价没有填写，不允许导入表格
   * 活动价，不符合数字规则。不允许导入（例：负数等）
   * 投放资源，单店限购，不符合数字规则，为空
   */
  async onImportUploadChange(dataJsonArr) {
    const MAX_LENGTH = 1000;
    let errorSalePriceLen = 0;
    const { matchMoney, matchZpNum } = this;
    try {
      const arrjson2Arr = arr => {
        return arr
          .map(el => {
            const skuInventory = el["投放资源（条）"];
            const maxPerUser = el["单店限购（条）"];
            return {
              skuCode: el["skuCode"],
              productCode: el["商品编码"],
              productName: `${el["规格"]} ${el["花纹"]}`,
              salePrice: el["活动价"],
              skuInventory: matchZpNum(skuInventory) ? skuInventory : null,
              maxPerUser: matchZpNum(maxPerUser) ? maxPerUser : null
            };
          })
          .filter(el => {
            if (
              el &&
              typeof el.salePrice !== "undefined" &&
              !matchMoney(el.salePrice)
            ) {
              errorSalePriceLen++;
            }
            return (
              el &&
              typeof el.salePrice !== "undefined" &&
              matchMoney(el.salePrice)
            );
          });
      };
      const list = arrjson2Arr(dataJsonArr);
      const dataList = await this.byProductCodeQueryProductList(list);
      if (errorSalePriceLen > 0) {
        this.$message.warning(
          `您导入的商品中有${errorSalePriceLen}件商品的活动价小于0，不符合活动规则，无法导入`
        );
        this.dataList = dataList;
      } else if (dataList.length > MAX_LENGTH) {
        this.$message.warning("单次导入文件，商品条数不能超过1K条");
        this.dataList = dataList.slice(0, MAX_LENGTH);
      } else {
        this.dataList = dataList;
      }
    } catch (error) {
      console.log(error);
    }
  }

   /**
   * 由于excel中没有商品名称，所以需要用批量商品code接口查询一次，获取商品名称等信息
   * 之后再进行数据格式化
   */
 async byProductCodeQueryProductList(dataList) {
    const productCodes = dataList.map(el => el.productCode);  
    const params = {
      productCodes,
      pageNum: 1,
      pageSize: 1000
    };
    const res = await this.queryPCRProductList(params);
      const { list } = res || {};
      const newDataList = dataList.map(el => {
        const findItem = list.find(item => item.productCode === el.productCode);
        if (findItem && findItem.status === 1) {
          return {
            ...el,
            productName: findItem.productName
          }
        }else {
          return null;
        }
      }).filter(el => el !== null);
    return newDataList;   
  }


  /**
   * 重置相关内容
   */
  resetDialog() {
    // 下载文件内容清空
    (this.$refs.importTemplateRef as any).toggleRemove();
    // 表格清空
    this.dataList = [];
  }
  async resetDialogData() {
    this.refClearSelection(["selectedTableRef"]);
    if (this.searchStr) {
      this.searchStr = null;
    }
    if (this.selectSearchStr) {
      this.selectSearchStr = null;
    }
  }
  refreshWrapTableData() {
    this.$nextTick(() => {
      (this.$refs.tableScrollWrapRef as any).toggleInit();
    });
  }
  /**
   * 校验金额，非空
   */
  matchMoney(val) {
    return moneyRegexp.test(val);
  }
  /**
   * 校验非零整数，可以是空，含义不一样
   */
  matchZpNum(val) {
    return zpNumRegexp.test(val);
  }
}
